import { Component, OnInit } from '@angular/core';
import { MemberService } from '../../services/member.service';
import { GlobalVar } from '../../globals/global-var';
import { Banner } from '../../models/banner';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {

  bannerList: Banner[] = [];

  constructor(private http: HttpClient, private memberService: MemberService, public globalVar: GlobalVar) {
    this.memberService.getBannerApi().subscribe(
      result => {
        this.bannerList = result;
      },
      err => {
        alert(JSON.stringify(err.error));
      },
      () => {

      }
    );
  }

  ngOnInit(): void {
  }


  addBanner() {
    this.bannerList.push({ id: 0, imgPath: '', imgLink: '' });
  }

  deleteBanner(index) {
    this.bannerList.splice(index, 1);
  }


  //檔案上傳
  uploadFile($event, index) {
    if ($event.target.files.length > 0) {
      const files = $event.target.files;
      if (!files) {
        return;
      }
      let formData: FormData = new FormData();
      formData.append('Files', files);
      for (let i = 0; i < files.length; i++) {
        let singleFile = files.item(i);
        // files 这个名字和spring mvc controller参数的名字要对应  
        formData.append('files', singleFile);
      }
      //檔案上傳
      this.http.post<any>(this.globalVar.targetIp + '/api/file', formData)
        .subscribe(
          result => {
            this.bannerList[index].imgPath = result.檔案名稱;
          },
          err => alert(err.error)
        );
      //上傳後將檔案清除
      $event.target.value = '';
    }
  }


  saveBanner() {
    this.memberService.postBannerApi(this.bannerList).subscribe(
      result => {
        alert(result.message);
      },
      err => {
        alert(JSON.stringify(err.error));
      },
      () => {

      }
    );
  }

}
